import { useEffect, useState } from 'react'
import LOGO_ICON from 'assets/images/logo/logo_horizon_white.png'
import SNS_BLOG_ICON from 'assets/images/footer/naver_blog_CI.png'
import SNS_POST_ICON from 'assets/images/footer/post_icon.png'
import SNS_INSTA_ICON from 'assets/images/footer/insta_CI.png'
import SNS_KAKAO_ICON from 'assets/images/footer/kakao_CI.png'
// import SNS_BLOG_ICON_PC from 'assets/images/footer/sns_blog_icon.png'
// import SNS_BLOG_ICON_MOBILE from 'assets/images/footer/sns_blog_icon_mobile.png'
// import SNS_POST_ICON_PC from 'assets/images/footer/sns_post_icon.png'
// import SNS_POST_ICON_MOBILE from 'assets/images/footer/sns_post_icon_mobile.png'
// import SNS_INSTA_ICON_PC from 'assets/images/footer/sns_instagram_icon.png'
// import SNS_INSTA_ICON_MOBILE from 'assets/images/footer/sns_instagram_icon_mobile.png'
// import SNS_KAKAO_ICON_PC from 'assets/images/footer/sns_kakao_icon.png'
// import SNS_KAKAO_ICON_MOBILE from 'assets/images/footer/sns_kakao_icon_mobile.png'
import {
    URL,
    TABLET,
    MOBILE,
    OUTER_URL,
    CEO_NAME,
    COMPANY_NAME_KO,
    COMPANY_NAME_EN,
    COMPANY_ADDRESS,
    COMPANY_CALL,
    COMPANY_FAX,
    PERSONAL_TERMS_MANAGE_NAME,
    PERSONAL_TERMS_MANAGE_EMAIL,
} from '../../utils/Utils'
import './Footer.scss'

/**
 * @file footer 영역
 */
function Footer() {
    // 사용자의 화면 너비
    const [width, setWidth] = useState(window.innerWidth)
    // 사용자의 화면 너비가 바뀔때마다 변수에 담아줌
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const footerSsn = (
        <div className="footer-ssn">
            <div>
                <ul>
                    <li>
                        <span className="corp-name">{COMPANY_NAME_KO} 주식회사</span>
                    </li>
                    <li>
                        대표자명 : {CEO_NAME}
                        &nbsp;&nbsp;/&nbsp;&nbsp;
                        {COMPANY_ADDRESS}
                    </li>
                    <li>사업자등록번호 : 571-88-02527</li>
                    <li>
                        개인정보보호책임자 : {PERSONAL_TERMS_MANAGE_NAME}
                        &nbsp;&nbsp;/&nbsp;&nbsp;고객센터 : {COMPANY_CALL}
                        &nbsp;&nbsp;/&nbsp;&nbsp;FAX : {COMPANY_FAX}
                    </li>
                    <li>Copyright 2022. DOTSTATION Co., Ltd. All rights reserved.</li>
                </ul>
            </div>
        </div>
    )
    const footerSsnMobile = (
        <div className="footer-ssn">
            <div>
                <ul>
                    <li>
                        <span className="corp-name">{COMPANY_NAME_KO} 주식회사</span>
                    </li>
                    <li>대표자명 : {CEO_NAME}</li>
                    <li>{COMPANY_ADDRESS}</li>
                    <li>사업자등록번호 : 571-88-02527</li>
                    <li>개인정보보호책임자 : {PERSONAL_TERMS_MANAGE_NAME}</li>
                    <li>
                        고객센터 : {COMPANY_CALL}
                        &nbsp;&nbsp;/&nbsp;&nbsp;FAX : {COMPANY_FAX}
                    </li>
                    <li>Copyright 2022. DOTSTATION Co., Ltd. All rights reserved.</li>
                </ul>
            </div>
        </div>
    )
    return (
        <footer>
            <div className="footer-inner">
                <img id="footer-logo" src={LOGO_ICON} alt={`${COMPANY_NAME_EN} logo`} />
                {/********************  PC크기 ********************/}
                {width >= TABLET ? (
                    <>
                        <div className="footer-flex">
                            <div>
                                <a className="link" href={URL.COMPANY.MAIN}>
                                    <div className="t1">회사소개</div>
                                </a>
                            </div>
                            <div>
                                <a className="link" href={URL.SCOOTER.MAIN}>
                                    <div className="t1">스마트 스쿠터</div>
                                </a>
                                {/* <div className="list">
                                    <a className="link" href={URL.SCOOTER.EV_C1}>
                                        EV-C1
                                    </a>
                                    <a className="link" href={URL.SCOOTER.S2}>
                                        고고로 S2
                                    </a>
                                    <a className="link" href={URL.SCOOTER.PLUS}>
                                        고고로 2 플러스
                                    </a>
                                    <a className="link" href={URL.SCOOTER.UTILITY}>
                                        고고로 2 유틸리티
                                    </a>
                                    <a className="link" href={URL.SCOOTER.XL}>
                                        고고로 VIVA XL
                                    </a>
                                    <a className="link" href={URL.SCOOTER.MIX}>
                                        고고로 VIVA MIX
                                    </a>
                                </div> */}
                            </div>
                            <div>
                                <a className="link" href={URL.NETWORK.MAIN}>
                                    <div className="t1">스왑 네트워크</div>
                                </a>
                                {/* <div className="list">
                                        <a className="link mb-55" href={URL.NEWS.MAIN}>
                                            새소식
                                        </a>
                                        2022.09.27 swyun 배포중인 고고로 홈페이지와 동일한 사항
                                        a.link(href=publicPath+"/news") 프로모션
                                    </div> */}
                            </div>
                            <div>
                                <a href={URL.RATE_PLAN.MAIN}>
                                    <div className="t1">요금제</div>
                                </a>
                            </div>
                            <div>
                                <a className="link" href={URL.NEWS.MAIN}>
                                    <div className="t1">최신소식</div>
                                </a>
                            </div>
                            <div>
                                <a className="link" href={URL.CUSTOMER.CUSTOMER_CENTER}>
                                    <div className="t1">고객지원</div>
                                </a>
                                {/* <div className="list">
                                    <a className="link" href={URL.CUSTOMER.CUSTOMER_CENTER}>
                                        고객센터
                                    </a>
                                    <a className="link" href={URL.CUSTOMER.EG_CARE}>
                                        EG CARE
                                    </a>
                                    <a className="link" href={URL.CUSTOMER.DOWNLOAD}>
                                        자료실
                                    </a>
                                    230621 서비스망이 갖춰진 이후 서비스네트워크 메뉴는  수정 후 오픈 예정
                                    {
                                        <a className="link" href={URL.CUSTOMER.SERVICE_NETWORK}>
                                            서비스네트워크
                                        </a>
                                    }
                                </div> */}
                            </div>
                            {/* 사전구매예약 */}
                            {/* <div>
                                <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                                    <div className="t1">차량 구매 문의</div>
                                </a>
                            </div> */}
                            <div>
                                <a
                                    className="link"
                                    target="_blank"
                                    href={OUTER_URL.PERSONAL_TERMS}
                                    rel="noopener noreferrer">
                                    <div className="t1 t2">개인정보처리방침</div>
                                </a>
                            </div>
                            {/* <div>
                                <a
                                    className="link"
                                    target="_blank"
                                    href={OUTER_URL.LOCATION_TERMS}
                                    rel="noopener noreferrer">
                                    <div className="t1 t2">위치기반서비스 이용약관</div>
                                </a>
                            </div> */}
                        </div>
                        {footerSsn}
                    </>
                ) : width >= MOBILE ? (
                    // ******************** 태블릿크기 ********************
                    <>
                        <div className="footer-flex">
                            <div>
                                <a className="link" href={URL.COMPANY.MAIN}>
                                    <div className="t1">회사소개</div>
                                </a>
                            </div>
                            <div>
                                <a className="link" href={URL.SCOOTER.MAIN}>
                                    <div className="t1">스마트 스쿠터</div>
                                </a>
                                {/* <div className="list">
                                    <a className="link" href={URL.SCOOTER.EV_C1}>
                                        EV-C1
                                    </a>
                                    <a className="link" href={URL.SCOOTER.S2}>
                                        고고로 S2
                                    </a>
                                    <a className="link" href={URL.SCOOTER.PLUS}>
                                        고고로 2 플러스
                                    </a>
                                    <a className="link" href={URL.SCOOTER.UTILITY}>
                                        고고로 2 유틸리티
                                    </a>
                                    <a className="link" href={URL.SCOOTER.XL}>
                                        고고로 VIVA XL
                                    </a>
                                    <a className="link" href={URL.SCOOTER.MIX}>
                                        고고로 VIVA MIX
                                    </a>
                                </div> */}
                            </div>
                            <div>
                                <a className="link" href={URL.NETWORK.MAIN}>
                                    <div className="t1">스왑 네트워크</div>
                                </a>

                                {/* <div className="list">
                                        <a className="link mb-55" href={URL.NEWS.MAIN}>
                                            새소식
                                        </a>
                                        2022.09.27 swyun 배포중인 고고로 홈페이지와 동일한 사항
                                        a.link(href=publicPath+"/news") 프로모션
                                    </div> */}
                            </div>
                            <div>
                                <a className="link" href={URL.RATE_PLAN.MAIN}>
                                    <div className="t1">요금제</div>
                                </a>
                            </div>
                            <div>
                                <a className="link" href={URL.NEWS.MAIN}>
                                    <div className="t1">최신소식</div>
                                </a>
                                {/* <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                                    <div className="t1">차량 구매 문의</div>
                                </a> */}
                            </div>
                            <div>
                                <a className="link" href={URL.CUSTOMER.CUSTOMER_CENTER}>
                                    <div className="t1">고객지원</div>
                                </a>
                                {/* <div className="list">
                                    <a className="link" href={URL.CUSTOMER.CUSTOMER_CENTER}>
                                        고객센터
                                    </a>
                                    <a className="link" href={URL.CUSTOMER.EG_CARE}>
                                        EG CARE
                                    </a>
                                    <a className="link" href={URL.CUSTOMER.DOWNLOAD}>
                                        자료실
                                    </a>

                                    230621 서비스망이 갖춰진 이후 서비스네트워크 메뉴는  수정 후 오픈 예정
                                    <a className="link" href={URL.CUSTOMER.SERVICE_NETWORK}>
                                        서비스네트워크
                                    </a>
                                </div> */}
                            </div>
                            <div>
                                <a
                                    className="link"
                                    target="_blank"
                                    href={OUTER_URL.PERSONAL_TERMS}
                                    rel="noopener noreferrer">
                                    <div className="t1 t2">개인정보처리방침</div>
                                </a>
                            </div>
                            {/* 26.10.21 위치기반서비스 이용약관 삭제 */}
                            {/* 
                            <div>
                                <a
                                    className="link"
                                    target="_blank"
                                    href={OUTER_URL.LOCATION_TERMS}
                                    rel="noopener noreferrer">
                                    <div className="t1 t2">위치기반서비스 이용약관</div>
                                </a>
                            </div>
                            */}
                            {/* 사전구매예약 */}
                        </div>
                        {footerSsn}
                    </>
                ) : (
                    // ******************** 모바일크기 ********************
                    <>
                        {footerSsnMobile}
                        <div className="footer-flex">
                            <a className="link" href={URL.COMPANY.MAIN}>
                                <div className="t1 ">회사소개</div>
                            </a>
                            <a className="link" href={URL.SCOOTER.MAIN}>
                                <div className="t1">스마트 스쿠터</div>
                            </a>
                            <a className="link" href={URL.NETWORK.MAIN}>
                                <div className="t1">스왑 네트워크</div>
                            </a>
                        </div>
                        <div className="footer-flex">
                            <a className="link" href={URL.RATE_PLAN.MAIN}>
                                <div className="t1">요금제</div>
                            </a>
                            <a className="link" href={URL.NEWS.MAIN}>
                                <div className="t1">최신소식</div>
                            </a>
                            <a className="link" href={URL.CUSTOMER.CUSTOMER_CENTER}>
                                <div className="t1">고객지원</div>
                            </a>
                        </div>
                        <div className="footer-flex">
                            <a
                                className="link"
                                target="_blank"
                                href={OUTER_URL.PERSONAL_TERMS}
                                rel="noopener noreferrer">
                                <div className="t1 t2">개인정보처리방침</div>
                            </a>
                            {/* 위치기반서비스 이용약관 삭제 */}
                            {/* <a
                                className="link"
                                target="_blank"
                                href={OUTER_URL.LOCATION_TERMS}
                                rel="noopener noreferrer">
                                <div className="t1 t2">위치기반서비스 이용약관</div>
                            </a> */}
                        </div>
                    </>
                )}
                <div className="footer-sns-wrap">
                    <img
                        className="footer-sns-img"
                        src={SNS_BLOG_ICON}
                        alt="블로그로 이동"
                        onClick={() => window.open(OUTER_URL.SNS_BLOG)}
                    />

                    {/* <img
                        className="footer-sns-img"
                        src={SNS_POST_ICON}
                        alt="포스트로 이동"
                        onClick={() => window.open(OUTER_URL.SNS_POST)}
                    /> */}

                    <img
                        className="footer-sns-img"
                        src={SNS_INSTA_ICON}
                        alt="인스타그램로 이동"
                        onClick={() => window.open(OUTER_URL.SNS_INSTA)}
                    />

                    <img
                        className="footer-sns-img"
                        src={SNS_KAKAO_ICON}
                        alt="카카오톡로 이동"
                        onClick={() => window.open(OUTER_URL.SNS_KAKAO)}
                    />
                </div>
            </div>
        </footer>
    )
}

export default Footer
